export default __webpack_public_path__ + "static/media/snowy.986a7b5d.png";